import Headroom from "headroom.js";

/**
 * GlobalHeader functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new GlobalHeader instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.navToggle = this.element.querySelector('[data-component="nav-toggle"]')
    this.cartToggle = this.element.querySelector('[data-component="cart-btn"]')
    this.miniCart = this.element.querySelector('[data-component="mini-cart"]')
    this.cartCloseBtn = this.element.querySelector('[data-component="cart-close"]')

    this.navToggle.addEventListener('click', e => {
      this.navToggle.classList.toggle('is-active')
      document.body.classList.toggle('nav-open')
    })

    this.cartToggle.addEventListener('click', (event) => {
      event.stopPropagation()
    })

    this.cartToggle.addEventListener('click', e => {
      document.body.classList.toggle('cart-open')
    })

    this.cartCloseBtn.addEventListener('click', e => {
      document.body.classList.remove('cart-open')
    })

    let headroom = new Headroom(this.element, {
      offset : 100
    })

    headroom.init()
  }
}



// WEBPACK FOOTER //
// ./components/global-header/index.js